const TeamsService = {
  teamMetrics: async (teamId) => {
    const response = await axios.get(`/api/teams/${teamId}/metrics`);
    const data = await response.data;
    return data;
  },
  audit: {
    async index(teamId, page = 1) {
      const response = await axios.get(`/api/settings/teams/${teamId}/audits?page=${page}`);
      const data = await response.data;
      return data;
    },
    async indexPersonal(page = 1) {
      const response = await axios.get(`/api/settings/teams/${teamId}/audits?page=${page}`);
      const data = await response.data;
      return data;
    },
    async get(teamId, auditId) {
      const response = await axios.get(`/api/teams/${teamId}/audits/${auditId}`);
      const data = await response.data;
      return data;
    },
  },
};

export default TeamsService;
